import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Lock, LockOpen, Pencil } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isFactureLocked = (doc) => doc.statut !== 'brouillon' && !doc.deverrouillee;

// Crayon (modifiable) / cadenas fermé (verrouillée, clic = déverrouiller) / cadenas ouvert (déverrouillée, clic = reverrouiller)
export const FactureVerrouActions = ({ doc, onEdit, onChanged, size = 'w-4 h-4' }) => {
  const [confirm, setConfirm] = useState(false);
  const locked = isFactureLocked(doc);
  const unlocked = doc.statut !== 'brouillon' && doc.deverrouillee;

  const toggle = async (deverrouillee) => {
    try {
      await axios.patch(`${API_URL}/factures/${doc.id}/verrou`, { deverrouillee });
      toast.success(deverrouillee ? `${doc.numero} déverrouillée — modification autorisée` : `${doc.numero} verrouillée`);
      setConfirm(false);
      onChanged?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur');
    }
  };

  const btn = 'flex items-center justify-center w-7 h-7 rounded';
  return (
    <>
      {locked ? (
        <button type="button" onClick={() => setConfirm(true)} className={`${btn} text-slate-400 hover:text-amber-600 hover:bg-amber-50`} title={`Verrouillée (${doc.statut}) — cliquer pour déverrouiller`} data-testid={`facture-lock-${doc.id}`}>
          <Lock className={size} />
        </button>
      ) : (
        <>
          {unlocked && (
            <button type="button" onClick={() => toggle(false)} className={`${btn} text-amber-600 hover:bg-amber-50`} title="Déverrouillée — cliquer pour reverrouiller" data-testid={`facture-unlock-${doc.id}`}>
              <LockOpen className={size} />
            </button>
          )}
          <button type="button" onClick={() => onEdit(doc)} className={`${btn} text-indigo-600 hover:bg-indigo-50`} title="Modifier la facture" data-testid={`facture-edit-${doc.id}`}>
            <Pencil className={size} />
          </button>
        </>
      )}
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Déverrouiller {doc.numero} ?</AlertDialogTitle>
            <AlertDialogDescription>
              Cette facture est au statut « {doc.statut} ». La déverrouiller permet d'en modifier le contenu. Elle sera automatiquement reverrouillée au prochain changement de statut.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={() => toggle(true)} className="bg-amber-600 hover:bg-amber-700" data-testid="facture-unlock-confirm">Déverrouiller</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
